// extracted by mini-css-extract-plugin
module.exports = {"varSpDown2":"0.5rem","ai-settings-item-container":"ai-settings-item-container--1a4f2","aiSettingsItemContainer":"ai-settings-item-container--1a4f2"};